export default __webpack_public_path__ + "static/media/blog_3_2.d34f12cc.jpg";